import TextReportGenerator from "../TextReportGenerator";
import ReportData from "../../ReportData";
import { saveClassByClassNameDecorator } from "../../../../shared/utils/classNameToConstructor";
import { DisplayedField } from "../../DisplayedField";

const DEFAULT_VERSION = "1";

const TITLE: string = "ClearVoyage Noon In Port Report";

const FIELDS: DisplayedField[] = [
  { fieldType: "IMONumber", required: true },
  { fieldType: "CurrentPort", required: true },
  { fieldType: "Captain", required: true },
  { fieldType: "ReportDate", required: true },
  { fieldType: "Remarks", required: false },
  { fieldType: "ConsumptionItems", required: true },
  { fieldType: "ROBItems", required: true },
  { fieldType: "DeparturePortETD", required: false },
  { fieldType: "DraftMid", required: true },
  { fieldType: "TotalLoadedDischarged", required: true },
  { fieldType: "TotalLoadedDischargedDay", required: true },
  { fieldType: "ToBeLoadedDischarged", required: true },
  { fieldType: "DraftFore", required: true },
  { fieldType: "DraftAft", required: true },
  { fieldType: "Anchorage", required: false },
];

@saveClassByClassNameDecorator()
class ClearVoyageNoonInPortReportGenerator extends TextReportGenerator {
  public constructor() {
    super(TITLE, FIELDS, DEFAULT_VERSION);
  }

  getReportText(_data: ReportData, _version: string | undefined): string {
    return "";
  }
}

export default ClearVoyageNoonInPortReportGenerator;
